var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"componentRef",class:_vm.$style.component,attrs:{"title":_vm.label}},[_c('ItemGraphics',{attrs:{"imageUrl":_vm.imageUrl,"label":_vm.label,"size":_vm.size,"labelType":_vm.labelType,"labelSize":_vm.labelSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }